export default "__VITE_ASSET__CeAgekV5__"